import {QuizInstance} from "../../../../Client/Models";
import React from "react";

const QuizContext = React.createContext<QuizInstance | undefined>(undefined);

export {
    QuizContext
}
